export enum PartnersEnum {
    Intel = 1,
    Microsoft = 2,
    AMD = 3,
    HPExclusive = 5,
}